export default __webpack_public_path__ + "2dc1fa3f991a1e8df3c5382d6324a0b3.png";